const OR = (leftCondition, rightCondition) => leftCondition || rightCondition;

export default OR;
